import React, { FC, useState, useEffect, useCallback, useRef } from 'react';
import classNames from 'classnames';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { useResizeObserver } from '@whitesharx/starfall-frontend-ui-kit';

import { fadeInStyles, fadeOutStyles, flashStyles, textStyles } from './styles.css';

type FlashProps = {
  show: boolean;
};

let timerId: NodeJS.Timeout | null;

const Flash: FC<FlashProps> = ({ show }) => {
  const [fontSize, setFontSize] = useState(0);
  const [className, setClassName] = useState<string>();
  const ref = useRef<HTMLDivElement>(null);

  const changeFontSize = useCallback((element: HTMLDivElement | null) => {
    setFontSize((element?.clientHeight || 0) / 2);
  }, []);

  useResizeObserver(ref.current, changeFontSize);

  useEffect(() => {
    if (show) {
      setClassName(fadeInStyles);

      timerId = setTimeout(() => {
        setClassName(fadeOutStyles);
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [show]);

  return (
    <div ref={ref} className={classNames(flashStyles, className)}>
      <div className={textStyles} style={{ fontSize }}>
        {t('game.check')}
      </div>
    </div>
  );
};

export default Flash;
